/* eslint-disable @typescript-eslint/no-floating-promises */
import { useEffect, useState } from "react";
import { getEmbaixadoresByProjeto } from "@/modules/projetos/firestore";

export const useGetEmbaixadoresAutocadastro = (
  empresaId: TEmpresa["id"],
  projeto: TProjeto,
  licenciadaId?: TLicenciada["id"] | undefined
) => {
  const [embaixadores, setEmbaixadores] = useState<TEmbaixador[]>([]);

  const loadEmbaixadores = async () => {
    const embaixadoresFound = await getEmbaixadoresByProjeto(empresaId, projeto, licenciadaId);
    const filteredEmbaixadores = embaixadoresFound.filter(
      (embaixador): embaixador is TEmbaixador => embaixador !== undefined
    );
    setEmbaixadores(filteredEmbaixadores);
  };

  const getEmbaixadoresData = () => {
    return embaixadores?.map((embaixador) => ({ value: embaixador.id, label: embaixador.nome }));
  };

  useEffect(() => {
    loadEmbaixadores();
  }, [empresaId, projeto.id]);

  return {
    embaixadores,
    embaixadoresData: getEmbaixadoresData()
  };
};
